import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

export default {
  headerTitleText: () => i18n.t(i18nKeys.deliveryIssue_header),
  merchantTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_merchant_title),
  requiredStepsTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_requiredSteps_title),
  requiredStepsDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_requiredSteps_description),
  additionalInfoTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_additionalInfo_title),
  additionalInfoDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_additionalInfo_description),
  additionalDetailsSubmittedText: () =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_additionalDetails_hasSubmitted),
  additionalDetailsNotSubmittedText: () =>
    i18n.t(
      i18nKeys.deliveryIssueDetail_section_additionalDetails_hasNotSubmitted
    ),
  dxEnteredGeoFenceTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxEnteredGeoFence_title),
  dxEnteredGeoFenceDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxEnteredGeoFence_description),
  dxContactedCxTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxContactedCx_title),
  dxContactedCxDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxContactedCx_description),
  dxWaitedTitleText: () => i18n.t(i18nKeys.deliveryIssueStep_DxWaited_title),
  dxWaitedDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxWaited_description),
  dxLeftPhotoTitleText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxLeftPhoto_title),
  dxLeftPhotoDescriptionText: () =>
    i18n.t(i18nKeys.deliveryIssueStep_DxLeftPhoto_description),
  missingSteps: ({ missed, total }) =>
    i18n.t(i18nKeys.deliveryIssueDetail_section_requiredSteps_missed_count, {
      missed,
      total,
    }),
}
